<template>
  <div class="modify-secondary-password">
    <div class="page-header">
      <h3>修改二级密码</h3>
      <p class="description">定期修改二级密码可以提高账号安全性</p>
    </div>
    
    <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" class="password-form">
      <el-form-item label="当前二级密码" prop="oldSecondaryPassword">
        <el-input 
          type="password" 
          v-model="formData.oldSecondaryPassword" 
          maxlength="20" 
          placeholder="请输入当前二级密码"
          show-password>
        </el-input>
      </el-form-item>
      
      <el-form-item label="新二级密码" prop="newSecondaryPassword">
        <el-input 
          type="password" 
          v-model="formData.newSecondaryPassword" 
          maxlength="20" 
          placeholder="请输入 6-20 位数字、字母或符号"
          show-password
          @input="handlePasswordInput">
        </el-input>
      </el-form-item>
      
      <el-form-item label="确认新密码" prop="confirmNewPassword">
        <el-input 
          type="password" 
          v-model="formData.confirmNewPassword" 
          maxlength="20" 
          placeholder="请再次输入新二级密码"
          show-password
          @input="handlePasswordInput">
        </el-input>
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确认修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getDeviceId, getDeviceModel } from '../../utils/deviceUtils'

export default {
  name: "ModifySecondaryPassword",
  data() {
    var validateOldSecondaryPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入当前二级密码'));
      }
      if (!/^[a-zA-Z0-9~!@#$%^&*()_+\-=\{\}\[\]:;"'<>,.?/\\\\]{6,20}$/.test(value)) {
        return callback(new Error('二级密码必须是 6-20 位数字、字母或符号'));
      }
      callback();
    };
    
    var validateNewSecondaryPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入新二级密码'));
      }
      if (!/^[a-zA-Z0-9~!@#$%^&*()_+\-=\{\}\[\]:;"'<>,.?/\\\\]{6,20}$/.test(value)) {
        return callback(new Error('二级密码必须是 6-20 位数字、字母或符号'));
      }
      if (value === this.formData.currentSecondaryPassword) {
        return callback(new Error('新密码不能与当前密码相同'));
      }
      callback();
    };
    
    var validateConfirmNewPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请确认新二级密码'));
      }
      if (value !== this.formData.newSecondaryPassword) {
        return callback(new Error('两次输入的密码不一致'));
      }
      callback();
    };
    
    return {
      formData: {
        terminal: this.$enums.TERMINAL_TYPE.WEB,
        oldSecondaryPassword: '',
        newSecondaryPassword: '',
        confirmNewPassword: '',
        deviceId: '',
        deviceModel: ''
      },
      rules: {
        oldSecondaryPassword: [
          { validator: validateOldSecondaryPassword, trigger: 'blur' }
        ],
        newSecondaryPassword: [
          { validator: validateNewSecondaryPassword, trigger: 'blur' }
        ],
        confirmNewPassword: [
          { validator: validateConfirmNewPassword, trigger: 'blur' }
        ]
      },
      submitting: false
    };
  },
  methods: {
    handlePasswordInput() {
      // 清空确认密码验证
      if (this.formData.confirmNewPassword) {
        this.$refs.formData.validateField('confirmNewPassword');
      }
    },
    handleSubmit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.submitting = true;
          
          // 获取设备信息
          const deviceId = getDeviceId();
          const deviceModel = getDeviceModel();
          
          // 构建提交数据
          const submitData = {
            terminal: this.formData.terminal,
            oldSecondaryPassword: this.formData.oldSecondaryPassword,
            newSecondaryPassword: this.formData.newSecondaryPassword,
            deviceId: deviceId,
            deviceModel: deviceModel
          };
          
          console.log('修改二级密码数据:', submitData);
          
          this.$http({
            url: "/user/modifySecondaryPassword",
            method: 'PUT',
            data: submitData
          }).then(() => {
            this.$message.success("修改成功");
            setTimeout(() => {
              // 通知父组件更新状态
              this.$parent.hasSecondaryPassword = true;
              this.$parent.checkSecondaryPassword();
              
              // 重置表单
              this.formData.oldSecondaryPassword = '';
              this.formData.newSecondaryPassword = '';
              this.formData.confirmNewPassword = '';
            }, 1500);
          }).catch((error) => {
            console.log("修改二级密码失败：", error);
          }).finally(() => {
            this.submitting = false;
          });
        }
      });
    },
    init() {
      // 获取设备信息
      this.formData.deviceId = getDeviceId();
      this.formData.deviceModel = getDeviceModel();
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped lang="scss">
.modify-secondary-password {
  padding: 30px;
  
  .page-header {
    margin-bottom: 30px;
    
    h3 {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin-bottom: 10px;
    }
    
    .description {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
    }
  }
  
  .password-form {
    max-width: 500px;
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    
    ::v-deep .el-form-item__label {
      font-weight: 500;
      color: #333;
    }
    
    ::v-deep .el-input__inner {
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
    }
    
    ::v-deep .el-button {
      width: 120px;
    }
  }
}
</style>
